<template>
  <div class="section-3 bg mt-4">

    <h2 class="section-3-title t2-c">تالار گفت و گو</h2>
    
    <div class="container-fluid px-4">
      <div class="row conversation-wrapper">
        
        <div class="col-md-8 col-sm-12">
          <div class="conversation" ref="container">
            <div v-if="!Object.keys(messages).length" class="empty">درحال حاضر هیچ گفت و گویی وجود ندارد.</div>

            <template v-else>
              <div v-for="(item , key) in messages" :key="key" class="message">
                <div class="profile">
                  <img :src="StaticImageUrl+'assets/images/empty-user.png'" alt="">
                </div>
                <div class="data">
                  <div class="title">
                    <template v-if="item.group">{{ item.group.fullname }}</template>
                    <template v-else>ادمین</template>
                  </div>
                  <div class="msg">
                    <pre v-html="item.text"></pre>
                  </div>
                  <div class="time">
                    <!-- 2 دقیقه پیش -->
                  </div>
                </div>
              </div>
            </template>

          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          
            <div class="px-5 py-3 chatroomform">
              <div class="row">
                <div class="col-sm-12 col-xs-12 my-2">
                  <div class="form-row">
                    <input type="text" :disabled="is_joined" @keypress="just_latin($event)" v-model="form_data.email" class="form-control" placeholder="ایمیل خود را وارد نمایید">
                    <div class="t2-c my-1" v-if="errors.email"><small> {{ errors.email[0] }} </small></div>
                  </div>
                </div>
                <div class="col-sm-12 col-xs-12 my-2">
                  <div class="form-row">
                    <input type="text" :disabled="is_joined" v-model="form_data.fullname" class="form-control" placeholder="نام مستعار خود را وارد نمایید">
                    <div class="t2-c my-1" v-if="errors.fullname"><small> {{ errors.fullname[0] }} </small></div>
                  </div>
                </div>
                <div class="px-2 chatroomtextbox my-2">
                  <div class="inner">
                    <div class="text-box">
                      <textarea v-model="message" placeholder="چیزی بنویسید"></textarea>
                    </div>
                    <!-- <div class="icons">
                      <i @click="sendMessage" class="fa fa-send"></i>
                    </div> -->
                  </div>
                </div>
                <div class="col-sm-12 col-xs-12 my-2">
                  <button @click="send()" class="--btn --btn-block --btn-theme">ارسال پیام</button>
                </div>
              </div>
            </div>
        </div>

      </div>
    </div>



  </div>
</template>
<script>
import {io} from 'socket.io-client';
export default {
  name: 'Chatroom',
  components:{
  },
  data : () => ({
    is_joined : false,
    form_data : {},
    message : '',
    errors : {},
    messages : {},
    socket : null
  }),
  watch:{
    
  },
  methods:{
    messageSender(evt){

      if (evt.keyCode == 13 && !evt.shiftKey) {
        this.sendMessage()
      }

    },
    getChatroomUser(mail){
      this.$axios.post(`getChatroomUser` , {email:mail})
      .then(res => {
        this.form_data = res.data.data
        this.is_joined = true
      })
      .catch(err => {
        this.$cookies.remove('chatroom_email')
        this.is_joined = false
      });
    },
    joinChatroom(){
      this.activeLoading(true)
      this.$axios.post(`joinChatroom` , this.form_data)
      .then(res => {
        const e = this.form_data.email
        this.$cookies.set("chatroom_email", e , 60*60*24*30*12);
        this.is_joined = true
        this.errors = {}
        this.activeLoading(false)
      })
      .catch(err => {
        this.errors = err.response.data.errors
        this.activeLoading(false)
      });
    },
    getMessages(){
      this.$axios.get(`getChatroomMessages`)
      .then(res => {
        this.messages = res.data.data

        const container = this.$refs.container;
        container.scrollTop = container.scrollHeight;
      })
      .catch(err => {
      });
    },
    sendMessage(){
      if(this.message == ''){
        return
      }

      this.$axios.post(`sendChatroomMessage` , {text : this.message , email : this.form_data.email})
      .then(res => {
        this.message = ''
        this.socket.emit('chatroom_message');
      })
      .catch(err => {
      });

    },
    send(){
      if(!this.is_joined)
      {
        this.joinChatroom()
      }else{
        this.sendMessage()
      }
    }
  },
  computed:{
  },
  mounted() {
    this.socket = io(this.socketUrl);
    this.getMessages()

    const mail = this.$cookies.get('chatroom_email');
    if(mail){
      this.getChatroomUser(mail)
      this.is_joined = true;
    }
    

    this.socket.on('chatroom_message', () => {
      this.getMessages()
    });

  },
  updated() {
    const container = this.$refs.container;
    container.scrollTop = container.scrollHeight;
  }
}
</script>